import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { legalRepresentativesInput } from './constants/contract-chip-inputs';
import { isLegalRepresentativeComplete } from './LegalRepresentativeUtils';
import getCompletionStatusChipStyles, {
  getCompletionStatusChipLabel,
} from './getCompletionStatusChipStyles';

const LegalRepresentativeItem = ({
  representative,
  expanded,
  onExpandedChange,
  onUpdate,
  onRemove,
}) => {
  const isComplete = isLegalRepresentativeComplete(representative);
  const displayName = representative.name?.trim() || 'Sin nombre';

  const handleRepresentativeFieldChange = (fieldId, value) => {
    const processedValue = fieldId === 'email' ? value.trim() : value;
    onUpdate(representative.id, { [fieldId]: processedValue });
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onExpandedChange(isExpanded)}
      disableGutters
      elevation={0}
      variant="bordered"
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" sx={{ flex: 1 }}>
          {displayName}
        </Typography>
        <Chip
          label={getCompletionStatusChipLabel(isComplete)}
          size="small"
          sx={getCompletionStatusChipStyles(isComplete)}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pb: 2 }}>
        <Stack spacing={2}>
          {legalRepresentativesInput.map((rowInputs) => (
            <Stack
              direction="row"
              spacing={2}
              sx={{ width: '100%' }}
              key={`legal-representative-row-${rowInputs[0].index}`}
            >
              {rowInputs.map((input) => (
                <input.component
                  key={`legal-representative-input-${input.id}-${representative.id}`}
                  input={input}
                  obj={representative}
                  handleInfoFunc={handleRepresentativeFieldChange}
                />
              ))}
            </Stack>
          ))}
          <Stack direction="row" justifyContent="flex-start">
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => onRemove(representative.id)}
            >
              Eliminar
            </Button>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

LegalRepresentativeItem.propTypes = {
  representative: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
    rut: PropTypes.string,
    nationality: PropTypes.string,
    profession: PropTypes.string,
    email: PropTypes.string,
    civilStatus: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default LegalRepresentativeItem;
